export default {
  getAutocompleteDocumentCategories: (state) => state.autocompleteDocumentCategories,
}